import { type ReactNode, useEffect } from 'react'
import { useRouter } from 'next/router'

import { useChildResourceForbidden } from '../hooks/use-child-resource-forbidden'

import { ChildResourceForbiddenScreen } from './child-resource-forbidden-screen'

interface ChildResourceForbiddenHandlerProps {
  children: ReactNode
}

export function ChildResourceForbiddenHandler({ children }: ChildResourceForbiddenHandlerProps) {
  const router = useRouter()
  const { activeError, reset } = useChildResourceForbidden()

  useEffect(() => {
    router.events.on('routeChangeStart', reset)
    return () => router.events.off('routeChangeStart', reset)
  }, [router.events, reset])

  if (activeError) return <ChildResourceForbiddenScreen info={activeError} />

  return children
}
